import { render, staticRenderFns } from "./ModifyCredits.vue?vue&type=template&id=09481c06&"
import script from "./ModifyCredits.vue?vue&type=script&lang=js&"
export * from "./ModifyCredits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports